import React, { useEffect, useState } from 'react'
import { adminApi } from '../services/api'
import { Loader, StatCard } from '../components/UI'
import { formatToman, toFaDigits, formatDateFa } from '../utils/format'
import toast from 'react-hot-toast'

const Reports: React.FC = () => {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [report, setReport] = useState<any>(null)
  const [userStats, setUserStats] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const load = async (start?: string, end?: string) => {
    setLoading(true)
    try {
      const params: Record<string, string> = {}
      if (start) params.startDate = new Date(start).toISOString()
      if (end) params.endDate = new Date(end).toISOString()
      const [r, u] = await Promise.all([adminApi.getSalesReport(params), adminApi.getUserStats()])
      if (r.data.success) setReport(r.data.data)
      setUserStats(u.data.data)
    } catch {
      toast.error('خطا در دریافت گزارش')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-black text-gray-900">گزارش فروش</h1>
          <p className="text-sm text-gray-500 mt-1">گزارش سفارش‌های تکمیل‌شده</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <input type="date" className="input !w-auto" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <span className="text-gray-400 text-sm">تا</span>
          <input type="date" className="input !w-auto" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          <button className="btn btn-primary" onClick={() => load(startDate, endDate)}>اعمال فیلتر</button>
        </div>
      </div>

      {loading ? (
        <div className="py-16 flex justify-center"><Loader /></div>
      ) : (
        <>
          <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
            <StatCard title="تعداد سفارش‌های تکمیل‌شده" value={toFaDigits(report?.totalOrders || 0)} icon="🧾" color="bg-blue-50 text-blue-700" />
            <StatCard title="درآمد کل" value={formatToman(report?.totalRevenue || 0)} icon="💵" color="bg-green-50 text-green-700" />
            <StatCard title="تعداد اقلام فروخته‌شده" value={toFaDigits(report?.totalItems || 0)} icon="📦" color="bg-gold-50 text-gold-700" />
            <StatCard title="کاربران دیدارکننده" value={toFaDigits(userStats?.total || 0)} icon="👥" />
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            {report?.period && (
              <div className="card p-5 text-sm text-gray-600">
                <b className="text-gray-900">دوره گزارش:</b>
                <br />از {formatDateFa(report.period.start)} تا {formatDateFa(report.period.end)}
              </div>
            )}
            {userStats && (
              <div className="card p-5 text-sm">
                <b className="text-gray-900">کاربران:</b>
                <div className="flex justify-between mt-2"><span className="text-gray-500">کل کاربران</span><b>{toFaDigits(userStats.total)}</b></div>
                <div className="flex justify-between mt-1"><span className="text-gray-500">کاربران فعال</span><b>{toFaDigits(userStats.active)}</b></div>
                <div className="flex justify-between mt-1"><span className="text-gray-500">کاربران دارای سفارش</span><b>{toFaDigits(userStats.withOrders)}</b></div>
              </div>
            )}
          </div>

          {report?.topProducts && report.topProducts.length > 0 && (
            <div className="card overflow-hidden">
              <div className="px-5 py-4 border-b border-gray-100 font-black">پرفروش‌ترین محصولات</div>
              <div className="table-wrap">
              <table className="table-admin">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>محصول</th>
                    <th>تعداد</th>
                    <th>درآمد</th>
                  </tr>
                </thead>
                <tbody>
                  {report.topProducts.map((p: any, i: number) => (
                    <tr key={p.id}>
                      <td>{toFaDigits(i + 1)}</td>
                      <td className="font-bold">{p.name}</td>
                      <td>{toFaDigits(p.quantity)}</td>
                      <td className="font-bold text-primary-700">{formatToman(p.revenue)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Reports